import { useMsal } from "@azure/msal-react";
import {jwtDecode} from "jwt-decode";

export const useLogin = () => {
  const { instance } = useMsal();

  const login = async () => {
    await instance.initialize();
    if(instance) {
      if (instance.getActiveAccount()) {
          console.log("User already logged in");
          return;
      }
      try {
          await instance.loginRedirect()
          console.log("Login successful");
      }
      catch(error){
            if (error.errorCode === "interaction_in_progress") {
                console.log("Interaction already in progress");
            } else {
                console.error(error);
            }
        };
    } 

    try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          const accessToken = response.idToken;
          const decodedToken = await jwtDecode(accessToken);
          sessionStorage.setItem('userId', decodedToken?.oid);          
          sessionStorage.setItem("bearerToken", accessToken);
        }
      } catch (error) {
        console.error("Error handling redirect:", error);
    }}
  return { login };
};
